var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Editar Vehículo" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "boton_crear", staticStyle: { height: "37px" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "icon",
                      staticStyle: {
                        "background-color": "rgb(255, 108, 0)",
                        "border-color": "rgb(255, 108, 0)",
                        "padding-right": "20px",
                        display: "block",
                        margin: "0 0 0 auto"
                      },
                      on: { click: _vm.editar }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "color-blanco",
                          staticStyle: { color: "white" }
                        },
                        [_vm._v("Guardar Cambios")]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" }
                    },
                    [
                      _c(
                        "v-container",
                        {
                          staticStyle: { padding: "30px 40px 50px 40px" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "FormFieldsContainer",
                            {
                              attrs: { titulo: "Asignación Detalle Vehículo" }
                            },
                            [
                              _vm._t("prependInformacionGeneral"),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label:
                                        _vm.formFields.codigovehiculo.label,
                                      disabled: ""
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.codigovehiculo.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.codigovehiculo,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.codigovehiculo.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.cliente.label,
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.formFields.cliente.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.cliente,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.cliente.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.nombreflota.label,
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.formFields.nombreflota.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.nombreflota,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.nombreflota.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.patente.label,
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.formFields.patente.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.patente,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.patente.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-combobox", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.formFields.marca.label,
                                      items: _vm.marcaslist,
                                      "item-text": "configvalor",
                                      "item-value": "configid",
                                      "error-messages": _vm.errors.collect(
                                        "marca"
                                      ),
                                      "data-vv-name": "marca",
                                      required: ""
                                    },
                                    on: { change: _vm.getmodelos },
                                    model: {
                                      value: _vm.formFields.marca.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.marca,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.marca.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  !_vm.cambio
                                    ? _c("v-combobox", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm.formFields.modelo.label,
                                          disabled: _vm.modoVer,
                                          items: _vm.modelolist,
                                          "item-text": "configvalor",
                                          "item-value": "configid",
                                          "error-messages": _vm.errors.collect(
                                            "modelo"
                                          ),
                                          "data-vv-name": "modelo",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.formFields.modelo.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.modelo,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.modelo.value"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.cambio
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.modelo.label
                                        },
                                        model: {
                                          value: _vm.formFields.modelo.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.modelo,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.modelo.value"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "required|numeric|anioMaximo|anioMinimo",
                                        expression:
                                          "'required|numeric|anioMaximo|anioMinimo'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Año",
                                      maxlength: "4",
                                      "error-messages": _vm.errors.collect(
                                        "ano"
                                      ),
                                      "data-vv-name": "ano",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.formFields.anio.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.anio,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.anio.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|co2|max:10",
                                        expression: "'required|co2|max:10'"
                                      }
                                    ],
                                    attrs: {
                                      label: "Emisión de Co2",
                                      "error-messages": _vm.errors.collect(
                                        "co2"
                                      ),
                                      "data-vv-name": "co2",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.formFields.co2.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.co2,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.co2.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.marcagps.label,
                                      disabled: _vm.modoVer,
                                      items: _vm.marcasgpslist,
                                      "item-text": "configvalor",
                                      "item-value": "configid",
                                      "data-vv-name": "marcagps",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.formFields.marcagps.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.marcagps,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.marcagps.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.modelogps.label,
                                      disabled: _vm.modoVer,
                                      items: _vm.modelogpslist,
                                      "item-text": "configvalor",
                                      "item-value": "configid",
                                      "data-vv-name": "modelogps",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.formFields.modelogps.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.modelogps,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.modelogps.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.nrosim.label,
                                      "data-vv-name": "nrosim",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.formFields.nrosim.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.nrosim,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.nrosim.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }